import { css } from '@emotion/react';

export const spotlightDialog = (dialogPosition, dialogWidthInPx) => css`
  top: ${dialogPosition?.top || 0}px;
  left: ${dialogPosition?.left || 0}px;
  position: fixed;
  border-radius: 16px;
  box-sizing: border-box;
  width: ${dialogWidthInPx}px;
`;

export const imageContainer = (height) => css`
  height: ${height}px;
  position: relative;

  ::before {
    content: '';
    position: absolute;
    top: 15%;
    left: -15px; /* push arrow to the left side */
    transform: translateY(-50%);
    width: 28px;
    height: 16px;
    background-color: #aa8fff;

    /* left-pointing triangle */
    clip-path: polygon(0 8px, 15px 0, 15px 16px);
  }
`;

export const image = css`
  border-radius: 16px 16px 0 0;
`;

export const textContainer = css`
  padding: 24px;
  background-color: #fff;
  border-radius: 0 0 16px 16px;
  width: 100%;
  box-sizing: border-box;
  white-space: pre-wrap;
`;

export const newFeatureButton = css`
  display: flex;
  justify-content: end;
  margin-top: 24px;
`;
